'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Heading } from '../ui/heading';
import { ModalClose } from '../ui/modal';
import { LuX } from 'react-icons/lu';
import { Paragraph } from '../ui/paragraph';
import { PartnerButton } from '../partner/partner-button';

function decodeHtmlEntities(text: string): string {
  return text
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'")
    .replace(/&nbsp;/g, ' ');
}

function parseListItems(html: string): string[] {
  const matches = html.match(/<li[^>]*>(.*?)<\/li>/g) ?? [];
  return matches.map(match => decodeHtmlEntities(match.replace(/<[^>]+>/g, '').trim())).filter(Boolean);
}

export function PackageModalContent({
  name,
  subtitle,
  description,
  itemIncludesContent,
  description2,
  goodForContent,
  investment,
}: {
  name: string;
  subtitle: string;
  description: string;
  itemIncludesContent: string;
  description2: string;
  goodForContent: string;
  investment: string;
}) {
  const { t } = useTranslations();

  const benefits: string[] = parseListItems(itemIncludesContent);
  const forWhos: string[] = parseListItems(goodForContent);

  console.log(benefits);

  return (
    <div className="flex w-full flex-col items-start justify-start gap-8">
      <div className="flex w-full items-start justify-between gap-6">
        <Heading title={`${t('text3550')} ${name}`} />
        <ModalClose>
          <LuX size={24} className="text-[#636264]" />
        </ModalClose>
      </div>
      {!!subtitle && (
        <strong className="text-2xl font-medium leading-[120%] tracking-tight text-[#3A332C] sm:text-3xl sm:leading-[120%] lg:text-[32px] lg:leading-[120%]">
          {subtitle}
        </strong>
      )}
      {!!description && (
        <Paragraph
          size="lg"
          innerHtml={description}
          className="ea-package-modal-content__paragraph w-full"
          color="foreground"
        />
      )}
      {!!benefits && benefits.length > 0 && (
        <div className="flex w-full flex-col items-start justify-start gap-4 rounded-[16px] bg-[#F2EDE6] p-4 sm:p-5 lg:p-6">
          <strong className="text-lg font-medium tracking-tight text-[#3A332C] sm:text-xl lg:text-2xl">
            {t('text3551')}:
          </strong>
          <ul className="flex w-full flex-col items-start justify-start gap-4">
            {benefits.map(benefit => (
              <li
                key={benefit}
                className="flex items-center justify-start gap-4 text-sm font-medium text-[#3A332C] sm:text-base lg:text-lg"
              >
                <Image
                  src={'/images/check-partner.svg'}
                  alt={benefit}
                  width={0}
                  height={0}
                  className="max-h-6 min-h-6 min-w-6 max-w-6 sm:max-h-[28px] sm:min-h-[28px] sm:min-w-[28px] sm:max-w-[28px]"
                />
                {benefit}
              </li>
            ))}
          </ul>
        </div>
      )}
      {!!description2 && (
        <Paragraph
          size="lg"
          innerHtml={description2}
          className="ea-package-modal-content__paragraph w-full"
          color="foreground"
        />
      )}
      {!!forWhos && forWhos.length > 0 && (
        <div className="flex w-full flex-col items-start justify-start gap-4">
          <strong className="text-lg font-medium tracking-tight text-[#3A332C] sm:text-xl lg:text-2xl">
            {t('text3552')}:
          </strong>
          <div className="flex w-full flex-wrap items-start justify-start gap-2 sm:gap-3">
            {forWhos.map(item => (
              <div
                key={item}
                className="flex w-fit items-center justify-center gap-2 rounded-[16px] border border-[#D3C7B8] bg-white p-2 sm:p-3 lg:gap-3 lg:p-4"
              >
                <Image
                  src={'/images/close.svg'}
                  alt={item}
                  width={0}
                  height={0}
                  className="max-h-6 min-h-6 min-w-6 max-w-6 lg:max-h-8 lg:min-h-8 lg:min-w-8 lg:max-w-8"
                />
                <p className="whitespace-nowrap text-xs font-normal text-foreground sm:text-sm lg:text-base xl:text-lg">
                  {item}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
      {!!investment && (
        <Paragraph className="font-bold" size="lg">
          {investment}
        </Paragraph>
      )}
      <PartnerButton />
    </div>
  );
}
